import { Component } from '@angular/core';

@Component({
  selector: 'app-connection-feedback',
  templateUrl: './connection-feedback.component.html',
  styleUrls: ['./connection-feedback.component.scss'],
})
export class ConnectionFeedbackComponent {}
